import { render, staticRenderFns } from "./FooterItem.vue?vue&type=template&id=b2afbd60"
import script from "./FooterItem.vue?vue&type=script&lang=js"
export * from "./FooterItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports